'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n'], ['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n']);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIPopoverHeader = require('./UIPopoverHeader');

var _UIPopoverHeader2 = _interopRequireDefault(_UIPopoverHeader);

var _UIPopoverBody = require('./UIPopoverBody');

var _UIPopoverBody2 = _interopRequireDefault(_UIPopoverBody);

var _UIPopoverFooter = require('./UIPopoverFooter');

var _UIPopoverFooter2 = _interopRequireDefault(_UIPopoverFooter);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _TwoWayTransition = require('../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _ClassNamePassthrough = require('../core/ClassNamePassthrough');

var _ClassNamePassthrough2 = _interopRequireDefault(_ClassNamePassthrough);

var _times = require('HubStyleTokens/times');

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var POSITION_RELATIVE = {
  position: 'relative'
};

var USE_CLASSES = {
  default: 'uiPopover--default private-popover--default',
  longform: 'private-tooltip--longform',
  shepherd: 'private-popover--shepherd',
  tooltip: 'private-popover--tooltip',
  'tooltip-danger': 'private-popover--tooltip private-popover--tooltip-danger',
  unstyled: 'private-popover--unstyled'
};

var getPopoverClassName = function getPopoverClassName(className, use) {
  return (0, _reactUtils.classNames)(className, USE_CLASSES[use], 'private-popover', 'uiPopover');
};

var renderArrow = function renderArrow(arrowColor, arrowSize, placement) {
  var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[arrowSize];
  return _react2.default.createElement(_UIPopoverArrow2.default, {
    color: arrowColor,
    inset: computedArrowParams.inset,
    key: 'arrow',
    placement: placement,
    width: computedArrowParams.width
  });
};

var renderStructuredContent = function renderStructuredContent(content, placement, renderedArrow) {
  var header = content.header,
      body = content.body,
      footer = content.footer;

  var headerArrow = placement.match(/bottom/) ? renderedArrow : null;
  var bodyArrow = placement.match(/bottom|top/) ? null : renderedArrow;
  var footerArrow = placement.match(/top/) ? renderedArrow : null;
  return [header ? _react2.default.createElement(
    _UIPopoverHeader2.default,
    { key: 'header' },
    header,
    headerArrow
  ) : headerArrow, body ? _react2.default.createElement(
    _UIPopoverBody2.default,
    { key: 'body' },
    body,
    bodyArrow
  ) : bodyArrow, footer ? _react2.default.createElement(
    _UIPopoverFooter2.default,
    { key: 'footer' },
    footer,
    footerArrow
  ) : footerArrow];
};

var renderPopoverContent = function renderPopoverContent(arrowColor, arrowSize, className, content, id, open, placement, width, style, use, rest) {
  var widthStyle = width ? { maxWidth: width, width: width } : {};
  var renderedArrow = renderArrow(arrowColor, arrowSize, placement);

  if (open) {
    return _react2.default.createElement(
      'div',
      _extends({
        className: getPopoverClassName(className, use),
        id: id,
        style: _extends({}, POSITION_RELATIVE, widthStyle, style)
      }, rest),
      _react2.default.isValidElement(content) ? [renderedArrow, _react2.default.createElement(
        'div',
        { key: 'content' },
        content
      )] : renderStructuredContent(content, placement, renderedArrow)
    );
  }

  return null;
};

var PopoverTransitionWrapper = (0, _styledComponents2.default)(_ClassNamePassthrough2.default).withConfig({
  displayName: 'UIPopoverContent__PopoverTransitionWrapper'
})(_templateObject, function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref2) {
  var duration = _ref2.duration;
  return duration;
}, function (props) {
  return props.hidden ? '0.01' : '1';
}, function (props) {
  return props.transitioning ? props.hidden ? 'scale(.75)' : 'scale(1)' : 'none';
});

var UIPopoverContent = _react2.default.createClass({
  displayName: 'UIPopoverContent',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool.isRequired,
    hasRendered: (0, _decorators.hidden)(_react.PropTypes.bool.isRequired),
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)).isRequired,
    className: _react.PropTypes.string,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    id: _react.PropTypes.string,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    style: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      animateOnToggle: true,
      hasRendered: false,
      open: false,
      placement: 'top',
      use: 'default'
    };
  },
  render: function render() {
    var _props = this.props,
        animateOnMount = _props.animateOnMount,
        animateOnToggle = _props.animateOnToggle,
        arrowColor = _props.arrowColor,
        arrowSize = _props.arrowSize,
        className = _props.className,
        content = _props.content,
        hasRendered = _props.hasRendered,
        id = _props.id,
        open = _props.open,
        placement = _props.placement,
        style = _props.style,
        use = _props.use,
        width = _props.width,
        rest = _objectWithoutProperties(_props, ['animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'className', 'content', 'hasRendered', 'id', 'open', 'placement', 'style', 'use', 'width']);

    return _react2.default.createElement(
      _TwoWayTransition2.default,
      {
        transitionOnMount: animateOnMount && !hasRendered || animateOnToggle && hasRendered,
        transitionOnUpdate: animateOnToggle,
        duration: parseInt(_times.POPOVER_TRANSITION_TIMING, 10),
        Wrapper: PopoverTransitionWrapper
      },
      renderPopoverContent(arrowColor, arrowSize, className, content, id, open, placement, width, style, use, rest)
    );
  }
});

exports.default = UIPopoverContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/tooltip/UIPopoverContent.js
// module id = 252
// module chunks = 0